// @flow
import { configureStore as reduxConfigureStore } from '@reduxjs/toolkit';
import config from './global/config';
import middlewares from './global/middlewares';
import reducer from './root-reducer';
import { translations } from './translations';
import {
  setDictionaries,
  setLanguages,
  setCurrentLanguage,
} from "./i18nReducer";

// Check for dev env, if false hide extensions like redux 
const { isDev, isBrowser } = config;
const devtools = isDev && isBrowser && window.devToolsExtension
  ? window.devToolsExtension
  : () => (fn) => fn;


console.warn = function () { };
console.error = function () { };

// console.log = function () { };

const dictionaries = translations;

const languages = [
  {
    code: 'en-US',
    name: 'English (USA)',
  },
];

const configureStore = (initialState = {}, services = {}) => {
  const store = reduxConfigureStore({
    reducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(middlewares),
  });
  // Initialize i18n state
  store.dispatch(setDictionaries(dictionaries));
  store.dispatch(setLanguages(languages));
  store.dispatch(setCurrentLanguage('en-US'));
  return store;
};

export default configureStore;
